module.exports = __webpack_public_path__ + "static/media/success.1a4a1c7e.png";